module.exports = __webpack_public_path__ + "img/PL08300.6c1a574e.png";